import { Component, inject, signal } from '@angular/core';
import { form, FormField, required, submit } from '@angular/forms/signals';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CreateUserDialogData } from '@app/components/user/create-user-dialog/create-user-dialog.component';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';

import { CompanyIndustriesDataService } from '@app/shared/services/company-industries-data.service';
import { CompanyIndustryFormModel } from '@app/shared/types/models/company/company-industry.model';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';
import { UiInputComponent } from '@app/shared/ui/input/ui-input.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-create-company-industry-dialog',
  imports: [MatDialogModule, TranslatePipe, UiDialogComponent, FormField, UiButtonComponent, UiInputComponent],
  templateUrl: './create-company-industry-dialog.component.html'
})
export class CreateCompanyIndustryDialogComponent {
  private readonly companyIndustriesDataService: CompanyIndustriesDataService = inject(CompanyIndustriesDataService);
  private readonly dialogRef: MatDialogRef<CreateCompanyIndustryDialogComponent> = inject(
    MatDialogRef<CreateCompanyIndustryDialogComponent>
  );
  private readonly dialogData: CreateUserDialogData = inject(MAT_DIALOG_DATA);

  protected readonly model = signal<CompanyIndustryFormModel>({ name: '' });
  protected readonly form = form(this.model, path => {
    required(path.name, { message: 'ui-forms-this-field-is-required' });
  });

  public save(): void {
    void submit(this.form, {
      action: async () => {
        this.companyIndustriesDataService.addCompanyIndustry(this.dialogData.pageParams, this.model());
        this.dialogRef.close();
      }
    });
  }
}
